
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ILocationCode } from "@tylertech/tyler-api-types";

/**
 * InventoryLocationService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class InventoryLocationService {
    private readonly $apiService = inject(ApiService);
    
    AddStockLocation(location: ILocationCode): Promise<ILocationCode> {
        return this.$apiService.sendAuth("IInventoryLocationService/AddStockLocation", location);
    }
}
